"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _typeof2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/typeof.js"));
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.find-index");
var _toConsumableArray2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _filter = _interopRequireDefault(require("@/components/filterDrawer/filter"));
var _MerchantElectricityConfigDialog = _interopRequireDefault(require("@/views/merchantElectricity/components/MerchantElectricityConfigDialog"));
var _selPlat = _interopRequireDefault(require("@/components/selPlat"));
var _area = _interopRequireDefault(require("@/components/area.json"));
var _editwith = _interopRequireDefault(require("../agent/_editwith"));
var _index = require("@/utils/index");
var _auth = require("@/utils/auth");
var _reportContent = require("@/utils/reportContent");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 【操作埋点】2026-05-25
 * 说明：content 格式化；$post 第三参数含 operation_id，成功后 request 拦截器自动上报
 */
var _default = exports.default = {
  name: 'SubShop',
  components: {
    Pagination: _Pagination.default,
    drawer: _filter.default,
    selPlat: _selPlat.default,
    editwith: _editwith.default,
    MerchantElectricityConfigDialog: _MerchantElectricityConfigDialog.default
  },
  props: {
    user_type: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    var _this = this;
    return {
      // 标签相关
      tagDialogVisible: false,
      currentStoreTags: [],
      currentStore: null,
      newTagInput: '',
      newTagInputVisible: false,
      search1: '',
      search2: '',
      search3: '',
      options_cshhr: [],
      options_dls: [],
      options_ywy: [],
      showPercent: _index.showPercent,
      form: {
        search_regions_tag: ''
      },
      beginOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.end) {
            return time.getTime() > _this.form.end || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      endOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.form.begin) {
            return time.getTime() < _this.form.begin || time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          } else {
            return time.getTime() > new Date(new Date().toLocaleDateString()).getTime();
          }
        }
      },
      sel_cat: [],
      categoryList: [],
      search_regions_tag: [],
      areaList: [],
      areaObj: {},
      give_role: [],
      tableMaxH: '250',
      is_clear_wx_user: 0,
      list: [],
      listLoading: true,
      frozenAvailableTotal: 0,
      listQuery: {
        sort_type: 0,
        search_user_type: 0,
        search_agent_id: '0',
        search_depend_type: '-1',
        search_son_type: 2,
        search_agent_level: 0,
        is_distributed: '2',
        is_frozen: '-1',
        days: 0,
        type: 1,
        start: 1,
        total: 10,
        page_num: 1
      },
      sort_type: ['综合排序', '收益从高到底', '收益从低到高', '创建时间由近到远', '创建时间由远到近', '登陆时间由近到远', '登陆时间由远到近', '月交易额由高到低', '月交易额由低到高'],
      selSnArr: [],
      zuo_sn: '',
      copyUrl: '',
      // 掉单设置
      isStealDialog: false,
      stealForm: {},
      stealStoreId: '',
      // 提现手续费
      withdrawFeeObj: {},
      withdrawFeeDialog: false,
      // 平台补贴比例设置
      balanceSetObj: {},
      banlanceSetDialog: false,
      // 撤销佣金设置
      cancelCommissionSetObj: {},
      cancelCommissionSetDialog: false,
      // 添加推广员
      addPromoterSetObj: {},
      addPromoterSetDialog: false,
      // 小程序广告设置
      offAdSetObj: {},
      offAdSetDialog: false,
      // 夜间服务费设置
      isNightSetObj: {},
      isNightSetDialog: false,
      // 概率押金设置
      isStoreYjObj: {},
      isStoreYjDialog: false,
      // 账号设置
      isFrozenSetObj: {},
      isFrozenDialog: false,
      // 余额增值
      isYezzSetObj: {},
      isShgsSetObj: {},
      isYezzDialog: false,
      isShgsDialog: false,
      isSyqkDialog: false,
      isSyqkObj: {},
      freeDialog: false,
      shopObj: {},
      /** 操作记录 */
      setRecordDialog: false,
      setRecordList: {},
      setRecordObj: {},
      entranceFeeDialog: false,
      entranceFeeObj: {},
      upTime: ['08:00', '20:00', '12:00', '24:00'],
      upMoneyDialog: false,
      upMoneyObj: {},
      select_aid: '',
      deviceBindStr: '',
      deviceBindDialog: false,
      deviceBindEndDialog: false,
      bind_success: [],
      bind_err: [],
      // 回本计算器
      breakEvenDialog: false,
      currentShopInfo: {},
      calculateCostLoading: false,
      deviceTypeOptions: [{
        value: '0',
        label: '全部'
      }, {
        value: '1',
        label: '充电宝'
      }, {
        value: '5',
        label: '充电桩'
      }, {
        value: '3',
        label: '充电线'
      }, {
        value: '9',
        label: '套套机'
      }],
      selectedDeviceType: '0',
      // 默认选中全部
      costForm: {
        deviceCost: '0',
        installationCost: '0',
        laborCost: '0',
        otherCost: '0',
        totalCost: '0',
        remark: '',
        // 设备成本
        cdbCost: '0',
        // 4G充电宝成本
        cdxCost: '0',
        // 充电线成本
        cdz10Cost: '0',
        // 10路桩成本
        cdz2Cost: '0',
        // 2路4G成本
        cdz2lyCost: '0',
        // 2路蓝牙成本
        cdz2hpCost: '0',
        // 2路大功率成本
        zmcdbCost: '0',
        // 桌面充电宝成本
        lykgczCost: '0',
        // 蓝牙开关插座成本
        // 安装成本
        cdbInstallCost: '0',
        cdxInstallCost: '0',
        cdz10InstallCost: '0',
        cdz2InstallCost: '0',
        cdz2lybInstallCost: '0',
        cdz2hpInstallCost: '0',
        zmcdbInstallCost: '0',
        lykgczInstallCost: '0',
        // 人工成本
        cdbLaborCost: '0',
        cdxLaborCost: '0',
        cdz2LaborCost: '0',
        cdz10LaborCost: '0',
        cdz2lybLaborCost: '0',
        cdz2hpLaborCost: '0',
        zmcdbLaborCost: '0',
        lykgczLaborCost: '0',
        // 其他成本
        cdbOtherCost: '0',
        cdxOtherCost: '0',
        cdz2OtherCost: '0',
        cdz10OtherCost: '0',
        cdz2lybOtherCost: '0',
        cdz2hpOtherCost: '0',
        zmcdbOtherCost: '0',
        lykgczOtherCost: '0'
      },
      investmentRatio: {
        partner: '0',
        manage: '0',
        proxy: '0',
        salesperson: '0',
        promoter: '0',
        merchants: '0'
      },
      // 各方回本占比数据
      recoveryRatio: {
        manage: '',
        partner: '',
        proxy: '',
        salesperson: '',
        promoter: '',
        merchants: ''
      },
      incomeRecords: [],
      totalIncome: 0,
      breakEvenDays: 0,
      breakEvenPercentage: 0,
      averageDailyIncome: 0,
      recoveredCost: 0,
      remainingCost: 0,
      daysSinceOperation: 0,
      averageChangeMoneyMonth: 0,
      // 充值金额配置
      rechargeConfigDialog: false,
      rechargeConfigObj: {
        aid: '',
        is_use_self_banner: 0,
        config_list: [{
          price: 50,
          send: 8
        }, {
          price: 30,
          send: 5
        }, {
          price: 20,
          send: 2
        }, {
          price: 10,
          send: '0.00'
        }, {
          price: 100,
          send: '0.00'
        }, {
          price: 200,
          send: '0.00'
        }]
      },
      // 我的分店
      branchDialogVisible: false,
      branchListLoading: false,
      branchList: [],
      mergeLoading: false,
      currentBranchRow: null
    };
  },
  computed: {
    filteredOptions1: function filteredOptions1() {
      var _this2 = this;
      // 计算属性，根据搜索条件过滤选项
      return this.options_cshhr.filter(function (option) {
        return option.label.toLowerCase().includes(_this2.search1.toLowerCase());
      });
    },
    filteredOptions2: function filteredOptions2() {
      var _this3 = this;
      // 计算属性，根据搜索条件过滤选项
      return this.options_dls.filter(function (option) {
        return option.label.toLowerCase().includes(_this3.search2.toLowerCase());
      });
    },
    filteredOptions3: function filteredOptions3() {
      var _this4 = this;
      // 计算属性，根据搜索条件过滤选项
      return this.options_ywy.filter(function (option) {
        return option.label.toLowerCase().includes(_this4.search3.toLowerCase());
      });
    },
    device: function device() {
      return this.$store.state.app.device;
    },
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    },
    deviceKeyObj: function deviceKeyObj() {
      return this.$store.state.user.deviceKeyObj;
    },
    siteInfo: function siteInfo() {
      return this.$store.getters.siteInfo;
    },
    agentInfo: function agentInfo() {
      return this.$store.getters.agentInfo;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (from.name == 'shopEdit') {
      to.meta.isBack = true;
    } else {
      to.meta.isBack = false;
    }
    next();
  },
  activated: function activated() {
    this.zuo_sn = this.$route.query.zuo_sn || '';
    if (this.$route.meta.isBack) {
      this.toQuery(2);
      this.getCategory();
      this.getArea();
    } else if (!this.list || this.list.length === 0) {
      this.getList();
    }
  },
  mounted: function mounted() {
    this.listQuery.search_user_type = this.user_type == 2 ? 0 : this.user_type;
    this.toQuery(2);
    this.getCategory();
    this.getArea();
    this.getOptionscshhr();
    this.getOptionsdls();
    this.getOptionsywy();
  },
  methods: {
    getToken: _auth.getToken,
    canElectricityConfig: function canElectricityConfig(row) {
      if (this.user_type != 0 && this.user_type != 1) return false;
      var deviceMap = this.deviceNameObj || {};
      var currentTab = String(this.listQuery.search_depend_type);

      // 充电桩 tab 下均可配置
      if (deviceMap['充电桩'] != null && currentTab === String(deviceMap['充电桩'])) {
        return true;
      }

      // 充电宝 / 充电线(密码线) tab 下均不可配置
      if (deviceMap['充电宝'] != null && currentTab === String(deviceMap['充电宝'])) {
        return false;
      }
      var cableTabType = deviceMap['密码线'] != null ? deviceMap['密码线'] : deviceMap['充电线'];
      if (cableTabType != null && currentTab === String(cableTabType)) {
        return false;
      }
      var name = row.depend_type_name || '';

      // 商户标识为充电宝或充电线/密码线，不可配置
      if (name.indexOf('充电宝') > -1) return false;
      if (name.indexOf('密码线') > -1 || name.indexOf('充电线') > -1) return false;

      // 有充电桩类设备数量，可配置
      if (this.hasChargingPileDevice(row)) return true;

      // 标识含充电桩，或其他非充电宝/充电线类型（如套套机、充电室等）
      return name.indexOf('充电桩') > -1 || name.length > 0;
    },
    hasChargingPileDevice: function hasChargingPileDevice(row) {
      return row.cdz10count > 0 || row.cdz16count > 0 || row.cdz2count > 0 || row.cdz2lycount > 0 || row.cdz2hpcount > 0;
    },
    openElectricityConfig: function openElectricityConfig(row) {
      if (!this.canElectricityConfig(row)) return;
      this.$refs.electricityConfig.open({
        aid: row.aid,
        merchant_name: row.name,
        store_name: row.store_name
      });
    },
    getStealInfo: function getStealInfo(id) {
      var _this5 = this;
      var url = 'agentapi/business/store_order_hidding';
      var params = {};
      if (this.type == 2) {
        url = 'agentapi/business/agent_order_hidding';
        params.son_id = id;
      } else {
        params.store_id = id;
      }
      this.stealStoreId = id;
      this.$get(url, params).then(function (res) {
        if (res.new_steal_switch == undefined) {
          res = {
            user_forbidden_finish: 0,
            steal_switch: 0,
            plan: [{
              begin: '00:00',
              end: '00:01'
            }],
            short_minute: 0,
            short_rate: 0,
            short_cycle_orders: 0,
            missed_rate: 0,
            missed_min_money: 0,
            show_fail_rate: 0,
            show_fail_min_money: 0,
            missed_cycle_orders: 0,
            missed_nologin_rate: 0,
            missed_nologin_min_money: 0,
            missed_nologin_hours: 0,
            missed_nologin_cycle_orders: 0,
            new_steal_switch: 0,
            degree_rate: 0
          };
        }
        _this5.stealForm = res;
      });
    },
    /**
     * 获取权限
     */
    getPower: function getPower() {
      var give_role = [{
        role_name: '全部',
        role_id: 0
      }];
      var roleKey = ['all_level_num', 'partner_level_num', 'agent_level_num', 'charge_level_num', 'manager_level_num'];
      var listQuery = Object.assign({}, this.listQuery, this.form);
      /* this.$get('agentapi/merchant_data_stat_num', listQuery).then(res => {
        this.$get('agentapi/add_agent').then(ares => {
          give_role = give_role.concat(ares.give_role_right)
          for (var i in give_role) {
            const role_id = give_role[i].role_id
            give_role[i].role_name = `${give_role[i].role_name}(${res[roleKey[role_id]] || 0})`
          }
          this.give_role = give_role
        })
      })*/
    },
    /**
     * 请求类型筛选
     * @param {Object} tab
     * @param {Object} event
     */
    typeClick: function typeClick(tab, event) {
      this.listQuery.order_type = tab.name;
      this.listQuery.start = 1;
      this.getList();
    },
    /**
     * 搜索查询
     */
    toQuery: function toQuery() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (this.$refs.filterDrawer) {
        this.$refs.filterDrawer.hide();
      }
      if (type == 1 || type == 2) {
        if (type == 2) {
          this.form = {
            son_id: this.$route.query.son_id
          };
        } else {
          this.form = {};
        }
        this.sel_cat = [];
        this.listQuery.start = 1;
      } else {
        this.listQuery.start = 1;
        if (this.search_regions_tag && this.search_regions_tag.length > 0) {
          this.form.search_regions_tag = this.search_regions_tag[this.search_regions_tag.length - 1];
        }
        this.listQuery.cat_id = this.sel_cat[1] ? this.sel_cat[1] : this.sel_cat[0];
      }
      this.getPower();
      this.getList();
    },
    /**
     * 获取商户类别
     */
    getCategory: function getCategory() {
      var _this6 = this;
      this.$get('agentapi/store/store_cat_list').then(function (res) {
        for (var i in res) {
          var obj = {
            value: res[i].cat_id,
            label: res[i].cat_name,
            children: [{
              value: 0,
              label: '全部'
            }]
          };
          if (res[i].son_cat_list.length > 0) {
            for (var s in res[i].son_cat_list) {
              var child = res[i].son_cat_list[s];
              obj.children.push({
                value: child.cat_id,
                label: child.cat_name
              });
            }
          }
          _this6.categoryList.push(obj);
        }
      });
    },
    getOptionscshhr: function getOptionscshhr() {
      var _this7 = this;
      this.$get('agentapi/store/store_gs_list', {
        role_id: 2
      }).then(function (res) {
        for (var i in res) {
          var obj = {
            value: res[i].aid,
            label: res[i].gs_name
          };
          _this7.options_cshhr.push(obj);
        }
      });
    },
    getOptionsdls: function getOptionsdls() {
      var _this8 = this;
      this.$get('agentapi/store/store_gs_list', {
        role_id: 3
      }).then(function (res) {
        for (var i in res) {
          var obj = {
            value: res[i].aid,
            label: res[i].gs_name
          };
          _this8.options_dls.push(obj);
        }
      });
    },
    getOptionsywy: function getOptionsywy() {
      var _this9 = this;
      this.$get('agentapi/store/store_gs_list', {
        role_id: 4
      }).then(function (res) {
        for (var i in res) {
          var obj = {
            value: res[i].aid,
            label: res[i].gs_name
          };
          _this9.options_ywy.push(obj);
        }
      });
    },
    /**
     * 获取区域
     */
    getArea: function getArea() {
      var res = _area.default;
      var areaObj = {};
      for (var i in res) {
        var firstLevel = res[i];
        var obj = {
          value: firstLevel.tag,
          label: firstLevel.title,
          children: []
        };
        areaObj[firstLevel.tag] = {
          title: firstLevel.title
        };
        if (firstLevel.son_list.length > 0) {
          var secondLevel = firstLevel.son_list;
          for (var s in secondLevel) {
            var secondItem = secondLevel[s];
            obj.children.push({
              value: secondItem.tag,
              label: secondItem.title,
              children: []
            });
            areaObj[secondItem.tag] = {
              title: secondItem.title
            };
            if (secondItem.son_list.length > 0) {
              var thirdLevel = secondItem.son_list;
              for (var t in thirdLevel) {
                var thirdItem = thirdLevel[t];
                obj.children[s].children.push({
                  value: thirdItem.tag,
                  label: thirdItem.title
                });
                areaObj[thirdItem.tag] = {
                  title: thirdItem.title
                };
              }
            } else {
              obj.children = undefined;
            }
          }
        } else {
          obj.children = undefined;
        }
        this.areaList.push(obj);
      }
      this.areaObj = areaObj;
    },
    getList: function getList() {
      var _this0 = this;
      var url = 'agentapi/search/query_stores';
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        start: this.listQuery.start - 1
      });
      if (listQuery.begin) listQuery.begin = this.parseTime(listQuery.begin, '{y}-{m}-{d}');
      if (listQuery.end) listQuery.end = this.parseTime(listQuery.end, '{y}-{m}-{d}');
      if (listQuery.query_month) {
        var t = listQuery.query_month.split('-');
        listQuery.query_year = t[0];
        listQuery.query_month = t[1];
      }
      this.$get(url, listQuery).then(function (res) {
        _this0.listLoading = false;
        var rows = Array.isArray(res.list) ? res.list : [];
        _this0.list = rows.map(function (item) {
          if (!item.label_list) {
            item.label_list = [];
          }
          return item;
        });
        _this0.listQuery.page_num = res.page_num || 0;
        //已冻结筛选时，记录可提金额总和
        _this0.frozenAvailableTotal = Number(res.frozen_available_total || 0);
        if (listQuery.start == 0 && _this0.$refs.list_table) {
          _this0.tableMaxH = window.innerHeight - _this0.$refs.list_table.$el.offsetTop - (_this0.user_type == 0 ? 83 : 123);
        }
        if (_this0.list.length > 0) {
          _this0.getBreakEvenCycleDataToList();
        }
      }).catch(function () {
        _this0.listLoading = false;
        _this0.list = [];
        _this0.listQuery.page_num = 0;
        _this0.frozenAvailableTotal = 0;
      });
    },
    /**
     * 铺货
     */
    distribu: function distribu(row) {
      var _this1 = this;
      var aid;
      var zuo_sn;
      var bind_success = [];
      var bind_err = [];
      if (row) {
        aid = row.aid;
        zuo_sn = this.zuo_sn;
      } else {
        aid = this.select_aid;
        zuo_sn = this.deviceBindStr;
      }
      if (!zuo_sn) {
        this.$message({
          message: '错误的设备码',
          type: 'error'
        });
        return;
      }
      this.$alert('确定将设备绑定到该商户吗？', '设备铺货', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            zuo_sn = zuo_sn.split(',');
            _this1.load = _this1.$message({
              duration: 0,
              iconClass: 'el-icon-loading',
              message: '绑定中'
            });
            for (var i in zuo_sn) {
              _this1.$post('agentapi/device/save_pickup_devices', {
                goods_sn: zuo_sn[i],
                son_id: aid
              }).then(/*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                  return regeneratorRuntime.wrap(function (_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        bind_success.push({
                          sn: zuo_sn[i],
                          msg: '绑定成功'
                        });
                        if (i == zuo_sn.length - 1) {
                          _this1.bindEnd(bind_success, bind_err);
                        }
                      case 1:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()).catch(function (err) {
                bind_err.push({
                  sn: zuo_sn[i],
                  msg: err.msg
                });
                if (i == zuo_sn.length - 1) {
                  _this1.bindEnd(bind_success, bind_err);
                }
              });
            }
          }
        }
      });
    },
    bindEnd: function bindEnd(bind_success, bind_err) {
      this.load.close();
      this.deviceBindEndDialog = true;
      this.bind_success = bind_success;
      this.bind_err = bind_err;
      if (bind_err.length == 0) {
        this.deviceBindDialog = false;
      }
    },
    /**
     * 编辑
     * @param {Object} row
     */
    toEdit: function toEdit(row) {
      var _this10 = this;
      switch (row.type) {
        case 1:
          break;
        case 2:
          this.$prompt('请输入冻结金额', '设置冻结金额', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: row.freez_money
          }).then(function (_ref2) {
            var value = _ref2.value;
            _this10.$post('agentapi/save_agent_freez_money', {
              son_id: row.id,
              freez_money: value
            }).then(function (res) {
              _this10.$message({
                message: '设置成功',
                type: 'success'
              });
              row.freez_money = value;
            });
          });
          break;
        case 4:
          this.$alert('确定删除此商户吗？', '删除商户', {
            confirmButtonText: '确定',
            callback: function callback(action) {
              if (action == 'confirm') {
                // 【操作埋点】2026-05-25 pc_shop_delete_1 删除商户
                _this10.$post('agentapi/sttuf/delete_merchant', {
                  store_id: row.id
                }, {
                  operation_option: '删除商户',
                  content: "\u5220\u9664\u5546\u6237\u300C".concat(row.store_name || '', "\u300D(ID:").concat(row.id, ")\uFF0C\u8054\u7CFB\u4EBA ").concat(row.name || '', "\uFF0C\u624B\u673A\u53F7 ").concat(row.mobile || ''),
                  operation_id: 'pc_shop_delete_1'
                }).then(function (res) {
                  _this10.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  _this10.list.splice(row.index, 1);
                });
              }
            }
          });
          break;
        case 5:
          this.$prompt('请输入新登录密码', '重置登录密码', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password',
            beforeClose: function beforeClose(action, instance, done) {
              if (action == 'confirm') {
                var value = instance.inputValue;
                _this10.$post('agentapi/save_merchant_password', {
                  son_id: row.aid,
                  password: value
                }).then(function (res) {
                  _this10.$message({
                    message: '设置成功',
                    type: 'success'
                  });
                  done();
                });
              } else {
                done();
              }
            }
          });
          break;
        case 6:
          this.$prompt('请输入商户营业时间', '设置营业时间', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'text',
            inputPlaceholder: '如：09:00-22:00',
            inputValue: row.row.business_time_des,
            beforeClose: function beforeClose(action, instance, done) {
              if (action == 'confirm') {
                var value = instance.inputValue;
                _this10.$post('agentapi/store/save_business_time', {
                  store_id: row.row.id,
                  business_time_des: value
                }).then(function (res) {
                  _this10.$message({
                    message: '设置成功',
                    type: 'success'
                  });
                  done();
                });
              } else {
                done();
              }
            }
          });
          break;
        case 7:
          this.$prompt('请输入新提现密码', '重置提现密码', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputType: 'password',
            beforeClose: function beforeClose(action, instance, done) {
              if (action == 'confirm') {
                var value = instance.inputValue;
                _this10.$post('agentapi/save_merchant_password', {
                  son_id: row.aid,
                  password: value,
                  type: 1
                }).then(function (res) {
                  _this10.$message({
                    message: '设置成功',
                    type: 'success'
                  });
                  done();
                });
              } else {
                done();
              }
            }
          });
          break;
        case 8:
          this.upMoneyDialog = true;
          this.$get('agentapi/sttuf/crontab_merchant_account', {
            son_id: row.aid
          }).then(function (res) {
            res.son_id = row.aid;
            _this10.upMoneyObj = res;
          });
          break;
        case 9:
          this.$get('agentapi/getAdminWithdrawConfig', {
            admin_id: row.aid
          }).then(function (res) {
            _this10.withdrawFeeDialog = true;
            _this10.withdrawFeeObj = res;
            _this10.withdrawFeeObj.admin_id = row.aid;
          });
          break;
        case 10:
          this.$get('agentapi/store/getDeposit', {
            store_id: row.id
          }).then(function (res) {
            _this10.banlanceSetDialog = true;
            _this10.balanceSetObj = res;
          });
          break;
        case 11:
          this.$get('agentapi/store/getStoreOffAd', {
            store_id: row.id
          }).then(function (res) {
            _this10.offAdSetDialog = true;
            _this10.offAdSetObj = res;
          });
          break;
        case 12:
          this.$get('agentapi/getCancelCommission', {
            store_id: row.id
          }).then(function (res) {
            _this10.cancelCommissionSetDialog = true;
            _this10.cancelCommissionSetObj = res;
          });
          break;
        case 13:
          this.$get('agentapi/admin/getFrozen', {
            admin_id: row.aid,
            store_id: row.id
          }).then(function (res) {
            _this10.isFrozenDialog = true;
            _this10.isFrozenSetObj = res;
            _this10.isFrozenSetObj.admin_id = row.aid;
            _this10.isFrozenSetObj.store_id = row.id;
          });
          break;
        case 14:
          this.$get('agentapi/store/getStoreIsNight', {
            store_id: row.id
          }).then(function (res) {
            _this10.isNightSetDialog = true;
            _this10.isNightSetObj = res;
          });
          break;
        case 15:
          this.$get('agentapi/store/getStoreYj', {
            store_id: row.id
          }).then(function (res) {
            _this10.isStoreYjDialog = true;
            _this10.isStoreYjObj = res;
          });
          break;
        case 16:
          this.$get('agentapi/admin/getYezz', {
            admin_id: row.aid
          }).then(function (res) {
            _this10.isYezzDialog = true;
            _this10.isYezzSetObj = res;
            _this10.isYezzSetObj.admin_id = row.aid;
          });
          break;
        case 17:
          this.load = this.$message({
            duration: 0,
            iconClass: 'el-icon-loading',
            message: '数据获取中'
          });
          this.$get('agentapi/admin/getSyqk', {
            id: row.id
          }).then(function (res) {
            _this10.isSyqkDialog = true;
            _this10.isSyqkObj = res;
            _this10.load.close();
          });
          break;
        case 18:
          this.$get('agentapi/admin/getShgs', {
            store_id: row.id
          }).then(function (res) {
            _this10.isShgsDialog = true;
            _this10.isShgsSetObj = res;
            _this10.isShgsSetObj.store_id = row.id;
          });
          break;
        case 19:
          this.$get('agentapi/sttuf/edit_promoter_agent', {
            store_id: row.id
          }).then(function (res) {
            if (res.code > 0) {
              _this10.$message({
                message: res.msg,
                type: 'error'
              });
              return;
            }
            if (res.agent_info.max_percent <= 0) {
              _this10.$message({
                message: '暂无分润可配置',
                type: 'error'
              });
              return;
            }
            _this10.addPromoterSetDialog = true;
            _this10.addPromoterSetObj = res.agent_info;
          });
          break;
      }
    },
    /**
     * 商户详情
     */
    getDetail: function getDetail(id) {
      var _this11 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var load = this.$message({
        duration: 0,
        iconClass: 'el-icon-loading',
        message: '请求中~~~'
      });
      this.$get('agentapi/my_merchant_detail', {
        store_id: id
      }).then(function (res) {
        load.close();
        if (type == 1) {
          if (_this11.siteInfo.first_free_right == 0 && !res.profit_info.first_free_switch) {
            _this11.$message({
              message: '系统首单免费功能已关闭，暂不支持开启首单免费',
              type: 'error'
            });
            return;
          }
          _this11.freeDialog = true;
          _this11.shopObj = {
            store_id: id,
            first_free_only_once: res.profit_info.first_free_only_once,
            first_free_switch: res.profit_info.first_free_switch
          };
        }
      });
    },
    /**
     * 设置首单免费
     */
    postFree: function postFree() {
      var _this12 = this;
      if (this.siteInfo.first_free_right == 0 && this.shopObj.first_free_switch) {
        this.$message({
          message: '系统首单免费功能已关闭，暂不支持开启首单免费，请关闭后提交',
          type: 'error'
        });
        return;
      }
      var load = this.$message({
        duration: 0,
        iconClass: 'el-icon-loading',
        message: '请求中~~~'
      });
      this.$post('agentapi/store/save_first_free', this.shopObj).then(function (res) {
        load.close();
        _this12.$message({
          message: '设置成功',
          type: 'success'
        });
        _this12.freeDialog = false;
      });
    },
    getSetSteal: function getSetSteal(id) {
      this.isStealDialog = true;
      this.getStealInfo(id);
    },
    /**
     * 提交会员卡信息
     */
    postCard: function postCard() {
      var _this13 = this;
      var url = 'agentapi/business/store_order_hidding';
      var params = JSON.parse(JSON.stringify(this.stealForm));
      params.store_id = this.stealStoreId;
      this.$post(url, params).then(function (res) {
        _this13.$message({
          message: '提交成功',
          type: 'success'
        });
      });
    },
    /**
     * 获取操作记录
     */
    getSetRecord: function getSetRecord(aid) {
      var _this14 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (type == 1) {
        this.setRecordObj.start = this.setRecordObj.start + 1;
      } else {
        this.setRecordList = {};
        this.setRecordObj = {
          aid: aid,
          start: 0,
          limit: 20,
          page_num: 1
        };
      }
      this.$get('agentapi/log/agent_records', this.setRecordObj).then(function (res) {
        if (res.list.length == 0 && _this14.setRecordObj.start == 0) {
          _this14.$message({
            message: '暂无记录',
            type: 'error'
          });
          return;
        }
        res.list.map(function (item) {
          return item.date = _this14.parseTime(item.add_date, '{y}-{m}-{d}');
        });
        res.list.map(function (item) {
          if (!_this14.setRecordList[item.date]) _this14.$set(_this14.setRecordList, item.date, {});
          if (!_this14.setRecordList[item.date].list) _this14.$set(_this14.setRecordList[item.date], 'list', []);
          _this14.setRecordList[item.date].list.push(item);
        });
        _this14.setRecordDialog = true;
        _this14.setRecordObj.page_num = res.page_num;
      });
    },
    /**
     * 滚动加载更多
     */
    loadSetRecord: function loadSetRecord() {
      if (this.setRecordObj.aid && this.setRecordObj.page_num > this.setRecordObj.start + 1) {
        this.getSetRecord('', 1);
      }
    },
    /**
     * 显示入场费
     */
    showEntranceFeeObj: function showEntranceFeeObj(row) {
      var _this15 = this;
      this.rowObj = row;
      this.entranceFeeDialog = true;
      this.entranceFeeObj = {
        store_id: row.id,
        divide_model: row.divide_model,
        store_door_fee_1: row.store_door_fee_1,
        door_fee_date: row.door_fee_date,
        promise_send_money: row.promise_send_money,
        door_relative_percent: row.door_relative_percent
      };
      this.$get('agentapi/sttuf/crontab_merchant_account', {
        son_id: row.aid
      }).then(function (res) {
        _this15.upMoneyObj = {
          son_id: row.aid,
          crond_money_type: 1,
          crond_once_unit_day: res.crond_once_unit_day,
          crond_min_money: 0,
          crond_once_unit_hour: 0
        };
      });
    },
    /**
     * 提交入场费
     */
    postEntranceFee: function postEntranceFee() {
      var _this16 = this;
      this.$post('agentapi/store/door_fee_date', this.entranceFeeObj).then(function (res) {
        _this16.entranceFeeDialog = false;
        _this16.rowObj.store_door_fee_1 = _this16.entranceFeeObj.store_door_fee_1;
        _this16.rowObj.door_fee_date = _this16.entranceFeeObj.door_fee_date;
        _this16.rowObj.divide_model = _this16.entranceFeeObj.divide_model;
        _this16.rowObj.promise_send_money = _this16.entranceFeeObj.promise_send_money;
        _this16.rowObj.door_relative_percent = _this16.entranceFeeObj.door_relative_percent;
        if (_this16.entranceFeeObj.divide_model == 2) {
          _this16.postUpMoney();
        } else {
          _this16.$message({
            type: 'success',
            message: '设置成功'
          });
        }
      });
    },
    /**
     * 提交提现金额更新规则
     */
    postUpMoney: function postUpMoney() {
      var _this17 = this;
      this.$post('agentapi/sttuf/crontab_merchant_account', this.upMoneyObj).then(function (res) {
        _this17.upMoneyDialog = false;
        _this17.$message({
          type: 'success',
          message: '设置成功'
        });
      });
    },
    /**
     * 设置提现手续费
     */
    setWithdrawFee: function setWithdrawFee() {
      var _this18 = this;
      // 【操作埋点】2026-05-25 pc_shop_withdraw_fee_1 设置提现手续费
      this.$post('agentapi/setAdminWithdrawConfig', {
        'admin_id': this.withdrawFeeObj.admin_id,
        'id': this.withdrawFeeObj.id,
        'config_mode': this.withdrawFeeObj.config_mode,
        'withdraw_rate': this.withdrawFeeObj.withdraw_rate,
        'withdraw_amount': this.withdrawFeeObj.withdraw_amount
      }, {
        operation_option: '设置提现手续费',
        content: (0, _reportContent.buildReportContent)(this.withdrawFeeObj, _reportContent.AGENT_WITHDRAW_FEE_LABELS, {
          prefix: "\u5546\u6237ID ".concat(this.withdrawFeeObj.admin_id)
        }),
        operation_id: 'pc_shop_withdraw_fee_1'
      }).then(function (res) {
        _this18.$message({
          message: '设置成功',
          type: 'success'
        });
        _this18.withdrawFeeDialog = false;
      });
    },
    setBalance: function setBalance() {
      var _this19 = this;
      // 【操作埋点】2026-05-25 pc_shop_deposit_1 设置余额/押金分成
      this.$post('agentapi/store/setDeposit', {
        'store_id': this.balanceSetObj.store_id,
        'is_deposit_sharing': this.balanceSetObj.is_deposit_sharing,
        'deposit_sharing_ratio': this.balanceSetObj.deposit_sharing_ratio,
        'agent_sharing_ratio': this.balanceSetObj.agent_sharing_ratio
      }, {
        operation_option: '设置余额',
        content: (0, _reportContent.buildReportContent)(this.balanceSetObj, _reportContent.SHOP_DEPOSIT_LABELS, {
          prefix: "\u5546\u6237ID ".concat(this.balanceSetObj.store_id),
          formatters: {
            is_deposit_sharing: _reportContent.formatYesNo
          }
        }),
        operation_id: 'pc_shop_deposit_1'
      }).then(function (res) {
        _this19.$message({
          message: '设置成功',
          type: 'success'
        });
        _this19.banlanceSetDialog = false;
      });
    },
    setStoreYj: function setStoreYj() {
      var _this20 = this;
      // 【操作埋点】2026-05-25 pc_shop_yj_1 设置佣金
      this.$post('agentapi/store/setStoreYj', {
        'store_id': this.isStoreYjObj.store_id,
        'is_sys_credit_percent_bao': this.isStoreYjObj.is_sys_credit_percent_bao,
        'low_wxcredit_switch': this.isStoreYjObj.low_wxcredit_switch,
        'low_wxcredit_percent_bao': this.isStoreYjObj.low_wxcredit_percent_bao,
        'low_zfbcredit_switch': this.isStoreYjObj.low_zfbcredit_switch,
        'low_zfbcredit_percent_bao': this.isStoreYjObj.low_zfbcredit_percent_bao
      }, {
        operation_option: '设置佣金',
        content: (0, _reportContent.buildReportContent)(this.isStoreYjObj, {
          is_sys_credit_percent_bao: '系统信用分成',
          low_wxcredit_switch: '微信低信用开关',
          low_wxcredit_percent_bao: '微信低信用分成',
          low_zfbcredit_switch: '支付宝低信用开关',
          low_zfbcredit_percent_bao: '支付宝低信用分成'
        }, {
          prefix: "\u5546\u6237ID ".concat(this.isStoreYjObj.store_id),
          formatters: {
            is_sys_credit_percent_bao: _reportContent.formatYesNo,
            low_wxcredit_switch: _reportContent.formatYesNo,
            low_zfbcredit_switch: _reportContent.formatYesNo
          }
        }),
        operation_id: 'pc_shop_yj_1'
      }).then(function (res) {
        _this20.$message({
          message: '设置成功',
          type: 'success'
        });
        _this20.isStoreYjDialog = false;
      });
    },
    showLoad: function showLoad() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '正在提交~~~';
      this.loadObj = this.$loading({
        lock: true,
        text: text,
        spinner: 'el-icon-loading'
      });
    },
    setCancelCommission: function setCancelCommission() {
      var _this21 = this;
      this.showLoad('正在提交~~~');

      // 【操作埋点】2026-05-25 pc_shop_commission_1 设置取消佣金
      this.$post('agentapi/setCancelCommission', {
        'store_id': this.cancelCommissionSetObj.store_id,
        'cancel_commission': this.cancelCommissionSetObj.cancel_commission,
        'cancel_order_commission_day': this.cancelCommissionSetObj.cancel_order_commission_day,
        'cancel_commision_rate': this.cancelCommissionSetObj.cancel_commision_rate
      }, {
        operation_option: '设置取消佣金',
        content: (0, _reportContent.buildReportContent)(this.cancelCommissionSetObj, {
          cancel_commission: '取消佣金',
          cancel_order_commission_day: '取消佣金天数',
          cancel_commision_rate: '取消佣金比例'
        }, {
          prefix: "\u5546\u6237ID ".concat(this.cancelCommissionSetObj.store_id),
          formatters: {
            cancel_commission: _reportContent.formatYesNo
          }
        }),
        operation_id: 'pc_shop_commission_1'
      }).then(function (res) {
        _this21.loadObj.close();
        _this21.$message({
          message: '设置成功',
          type: 'success'
        });
        _this21.cancelCommissionSetDialog = false;
      });
    },
    addPromoter: function addPromoter() {
      var _this22 = this;
      this.showLoad('正在提交~~~');
      if (this.addPromoterSetObj.store_percent > this.addPromoterSetObj.max_percent) {
        this.$message({
          message: '最大比例不能超过' + this.addPromoterSetObj.max_percent + '%',
          type: 'error'
        });
        this.loadObj.close();
        return;
      }
      // 【操作埋点】2026-05-25 pc_shop_promoter_1 添加推广员
      this.$post('agentapi/sttuf/save_promoter_add_agent', {
        'store_id': this.addPromoterSetObj.store_id,
        'name': this.addPromoterSetObj.name,
        'phone': this.addPromoterSetObj.phone,
        'store_percent': this.addPromoterSetObj.store_percent,
        'is_delete': this.addPromoterSetObj.is_delete,
        'max_percent': this.addPromoterSetObj.max_percent
      }, {
        operation_option: '添加推广员',
        content: (0, _reportContent.buildReportContent)(this.addPromoterSetObj, {
          name: '推广员姓名',
          phone: '手机号',
          store_percent: '分成比例',
          max_percent: '最大比例',
          is_delete: '是否删除'
        }, {
          prefix: "\u5546\u6237ID ".concat(this.addPromoterSetObj.store_id),
          formatters: {
            is_delete: _reportContent.formatYesNo
          }
        }),
        operation_id: 'pc_shop_promoter_1'
      }).then(function (res) {
        _this22.loadObj.close();
        _this22.$message({
          message: '设置成功',
          type: 'success'
        });
        _this22.addPromoterSetDialog = false;
      });
    },
    setOffAd: function setOffAd() {
      var _this23 = this;
      // 【操作埋点】2026-05-25 pc_shop_ad_1 设置广告开关
      this.$post('agentapi/store/setStoreOffAd', {
        'store_id': this.offAdSetObj.store_id,
        'off_ad': this.offAdSetObj.off_ad
      }, {
        operation_option: '设置广告',
        content: "\u5546\u6237ID ".concat(this.offAdSetObj.store_id, "\uFF0C\u5173\u95ED\u5E7F\u544A\uFF1A").concat((0, _reportContent.formatYesNo)(this.offAdSetObj.off_ad)),
        operation_id: 'pc_shop_ad_1'
      }).then(function (res) {
        _this23.$message({
          message: '设置成功',
          type: 'success'
        });
        _this23.offAdSetDialog = false;
      });
    },
    setIsNight: function setIsNight() {
      var _this24 = this;
      // 【操作埋点】2026-05-25 pc_shop_night_1 设置夜间模式
      this.$post('agentapi/store/setStoreIsNight', {
        'store_id': this.isNightSetObj.store_id,
        'is_night': this.isNightSetObj.is_night
      }, {
        operation_option: '设置夜间模式',
        content: "\u5546\u6237ID ".concat(this.isNightSetObj.store_id, "\uFF0C\u591C\u95F4\u6A21\u5F0F\uFF1A").concat((0, _reportContent.formatYesNo)(this.isNightSetObj.is_night)),
        operation_id: 'pc_shop_night_1'
      }).then(function (res) {
        _this24.$message({
          message: '设置成功',
          type: 'success'
        });
        _this24.isNightSetDialog = false;
      });
    },
    show_confirm: function show_confirm() {
      var _this25 = this;
      this.$confirm('确定清除绑定的用户吗？', '解绑用户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        console.log('清除解绑');
        console.log(_this25.isFrozenSetObj.admin_id);
        // 【操作埋点】2026-05-25 pc_shop_account_1 解绑用户
        _this25.$post('agentapi/ucenter/save_bind_info', {
          agent_aid: _this25.isFrozenSetObj.admin_id
        }, {
          operation_option: '解绑用户',
          content: "\u5546\u6237ID\uFF1A".concat(_this25.isFrozenSetObj.admin_id),
          operation_id: 'pc_shop_account_1'
        }).then(function (res) {
          _this25.$message({
            message: '清除解绑成功',
            type: 'success'
          });
          _this25.isFrozenDialog = false;
        });
      }).catch(function () {
        _this25.is_clear_wx_user = 0;
      });
    },
    setFrozen: function setFrozen() {
      var _this26 = this;
      // 【操作埋点】2026-05-25 pc_shop_account_1 账号设置
      this.$post('agentapi/admin/setFrozen', {
        'admin_id': this.isFrozenSetObj.admin_id,
        'store_id': this.isFrozenSetObj.store_id,
        'is_use_cheap': this.isFrozenSetObj.is_use_cheap,
        'is_allow_withdrawal': this.isFrozenSetObj.is_allow_withdrawal,
        'is_frozen': this.isFrozenSetObj.is_frozen,
        'is_steal_order_white': this.isFrozenSetObj.is_steal_order_white,
        'is_use_old_combo': this.isFrozenSetObj.is_use_old_combo,
        'is_use_hour_position': this.isFrozenSetObj.is_use_hour_position,
        'is_show_cdz_combo': this.isFrozenSetObj.is_show_cdz_combo
      }, {
        operation_option: '账号设置',
        content: (0, _reportContent.buildReportContent)(this.isFrozenSetObj, _reportContent.SHOP_FROZEN_LABELS, {
          prefix: "\u5546\u6237ID ".concat(this.isFrozenSetObj.store_id),
          formatters: {
            is_frozen: _reportContent.formatYesNo,
            is_allow_withdrawal: _reportContent.formatYesNo,
            is_use_cheap: _reportContent.formatYesNo,
            is_steal_order_white: _reportContent.formatYesNo,
            is_show_cdz_combo: _reportContent.formatYesNo,
            is_use_hour_position: _reportContent.formatYesNo,
            is_use_old_combo: _reportContent.formatYesNo
          }
        }),
        operation_id: 'pc_shop_account_1'
      }).then(function (res) {
        _this26.$message({
          message: '设置成功',
          type: 'success'
        });
        _this26.isFrozenDialog = false;
      });
    },
    setYezz: function setYezz() {
      var _this27 = this;
      // 【操作埋点】2026-05-25 pc_shop_yezz_1 认证设置
      this.$post('agentapi/admin/setYezz', {
        'admin_id': this.isYezzSetObj.admin_id,
        'is_yezz': this.isYezzSetObj.is_yezz
      }, {
        operation_option: '认证设置',
        content: "\u5546\u6237ID ".concat(this.isYezzSetObj.admin_id, "\uFF0C\u8BA4\u8BC1\u72B6\u6001\uFF1A").concat((0, _reportContent.formatYesNo)(this.isYezzSetObj.is_yezz)),
        operation_id: 'pc_shop_yezz_1'
      }).then(function (res) {
        _this27.$message({
          message: '设置成功',
          type: 'success'
        });
        _this27.isYezzDialog = false;
      });
    },
    setShgs: function setShgs() {
      var _this28 = this;
      // 【操作埋点】2026-05-25 pc_shop_shgs_1 设置商户归属
      this.$post('agentapi/admin/setShgs', {
        'cshhr': this.isShgsSetObj.cshhr,
        'dls': this.isShgsSetObj.dls,
        'ywy': this.isShgsSetObj.ywy,
        'store_id': this.isShgsSetObj.store_id,
        'cshhr_cdb_percent': this.isShgsSetObj.cshhr_cdb_percent,
        'cshhr_cdx_percent': this.isShgsSetObj.cshhr_cdx_percent,
        'cshhr_cdz_percent': this.isShgsSetObj.cshhr_cdz_percent,
        'dls_cdb_percent': this.isShgsSetObj.dls_cdb_percent,
        'dls_cdx_percent': this.isShgsSetObj.dls_cdx_percent,
        'dls_cdz_percent': this.isShgsSetObj.dls_cdz_percent,
        'ywy_cdb_percent': this.isShgsSetObj.ywy_cdb_percent,
        'ywy_cdx_percent': this.isShgsSetObj.ywy_cdx_percent,
        'ywy_cdz_percent': this.isShgsSetObj.ywy_cdz_percent,
        'sj_cdb_percent': this.isShgsSetObj.sj_cdb_percent,
        'sj_cdx_percent': this.isShgsSetObj.sj_cdx_percent,
        'sj_cdz_percent': this.isShgsSetObj.sj_cdz_percent
      }, {
        operation_option: '设置商户归属',
        content: (0, _reportContent.buildReportContent)(this.isShgsSetObj, {
          cshhr: '城市合伙人',
          dls: '代理商',
          ywy: '业务员',
          cshhr_cdb_percent: '合伙人充电宝分成',
          dls_cdb_percent: '代理充电宝分成',
          ywy_cdb_percent: '业务员充电宝分成',
          sj_cdb_percent: '上级充电宝分成'
        }, {
          prefix: "\u5546\u6237ID ".concat(this.isShgsSetObj.store_id)
        }),
        operation_id: 'pc_shop_shgs_1'
      }).then(function (res) {
        _this28.$message({
          message: '设置成功',
          type: 'success'
        });
        _this28.isShgsDialog = false;
      });
    },
    /**
     * 修改商户的部分
     */
    editShopPart: function editShopPart(row) {
      var _this29 = this;
      var advance_buletooth = row.advance_buletooth == 1 ? 0 : 1;

      // 【操作埋点】2026-05-25 pc_shop_edit_1 修改商户设置项
      this.$post('agentapi/store/type_switch', {
        store_id: row.id,
        type: 1,
        agree: advance_buletooth
      }, {
        operation_option: '修改商户设置',
        content: "\u5546\u6237ID\uFF1A".concat(row.id),
        operation_id: 'pc_shop_edit_1'
      }).then(function (res) {
        row.advance_buletooth = advance_buletooth;
        _this29.$message({
          type: 'success',
          message: '设置成功'
        });
      });
    },
    /**
     * 跳转至创建客服跟进记录
     */
    handleCreateCustomerRecord: function handleCreateCustomerRecord(row) {
      var on_goods_type = '0';
      if (row.cdbcount > 0) {
        on_goods_type = '1';
      }
      if (row.cdxcount > 0) {
        on_goods_type = '3';
      }
      if (row.cdz10count > 0 || row.cdz2count > 0 || row.cdz2lycount > 0 || row.cdz2hpcount > 0 || row.lykgczcount > 0) {
        on_goods_type = '5';
      }
      if (row.zmcdbcount > 0) {
        on_goods_type = '11';
      }
      this.$router.push({
        path: '/run/customerRecord',
        query: {
          page_call_type: 'create',
          store_id: row.id,
          store_name: row.store_name,
          phone: row.mobile,
          name: row.name,
          aid: row.aid,
          goods_type: on_goods_type
        }
      });
    },
    /**
     * 打开我的分店弹窗
     */
    openBranchDialog: function openBranchDialog(row) {
      var _this30 = this;
      this.currentBranchRow = row;
      this.branchDialogVisible = true;
      this.branchListLoading = true;
      this.branchList = [];
      var url = 'agentapi/search/query_stores';
      var params = Object.assign({}, this.listQuery, {
        major_pid: row.aid,
        search_user_type: 1,
        start: 0,
        limit: 100
      });
      delete params.page_num;
      this.$get(url, params).then(function (res) {
        _this30.branchListLoading = false;
        _this30.branchList = res.list || [];
      }).catch(function () {
        _this30.branchListLoading = false;
        _this30.branchList = [];
      });
    },
    /**
     * 一键合并分店可提金额到总店
     */
    handleMergeFunds: function handleMergeFunds() {
      var self = this;
      if (!self.currentBranchRow) {
        self.$message.warning('未找到总店信息');
        return;
      }
      var branchList = self.branchList.filter(function (item) {
        return Number(item.available_withdraw_money) > 0;
      });
      if (branchList.length === 0) {
        self.$message.warning('暂无可合并的分店资金');
        return;
      }
      var totalMoney = branchList.reduce(function (sum, item) {
        return sum + Number(item.available_withdraw_money || 0);
      }, 0);
      var confirmMsg = '确认将 ' + branchList.length + ' 个分店的可提金额（合计￥' + totalMoney.toFixed(2) + '）合并到总店吗？';
      self.$confirm(confirmMsg, '资金合并确认', {
        confirmButtonText: '确定合并',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        self.mergeLoading = true;
        self.$post('agentapi/search/merge_branch_funds', {
          major_pid: self.currentBranchRow.aid
        }).then(function (res) {
          self.mergeLoading = false;
          self.$message.success(res.msg);
          self.openBranchDialog(self.currentBranchRow);
        }).catch(function () {
          self.mergeLoading = false;
          self.$message.error('请求失败，请稍后重试');
        });
      }).catch(function () {});
    },
    /**
     * 跳转至客服跟进记录详情
     */
    handleViewCustomerDetail: function handleViewCustomerDetail(row) {
      this.$router.push({
        path: '/run/customerRecord',
        query: {
          page_call_type: 'query',
          store_id: row.id
        }
      });
    },
    /**
     * 显示所有标签
     */
    showAllTags: function showAllTags(row) {
      this.currentStore = row;
      this.currentStoreTags = (0, _toConsumableArray2.default)(row.label_list || []);
      this.tagDialogVisible = true;
    },
    /**
     * 编辑标签
     */
    editTags: function editTags(row) {
      this.currentStore = row;
      this.currentStoreTags = (0, _toConsumableArray2.default)(row.label_list || []);
      this.tagDialogVisible = true;
    },
    /**
     * 添加新标签
     */
    addNewTag: function addNewTag() {
      var _this31 = this;
      if (this.newTagInput.trim() !== '') {
        // 检查是否已存在同名标签
        var exists = this.currentStoreTags.some(function (tag) {
          return tag.label_name === _this31.newTagInput.trim();
        });
        if (!exists) {
          // 添加新标签到服务器
          // 【操作埋点】2026-05-25 pc_shop_edit_1 添加商户标签
          this.$post('agentapi/store/addLabel', {
            label_name: this.newTagInput.trim(),
            store_id: this.currentStore.id,
            aid: this.currentStore.aid
          }, {
            operation_option: '添加标签',
            content: "\u5546\u6237ID\uFF1A".concat(this.currentStore.id, "\uFF0C\u6807\u7B7E\uFF1A").concat(this.newTagInput.trim()),
            operation_id: 'pc_shop_edit_1'
          }).then(function (res) {
            // 添加成功后更新本地标签列表
            _this31.currentStoreTags.push({
              id: parseInt(res.id),
              // 使用服务器返回的ID
              aid: _this31.currentStore.aid,
              label_name: res.label_name
            });
            _this31.$message({
              message: '标签添加成功',
              type: 'success'
            });
          }).catch(function (err) {
            _this31.$message({
              message: '标签添加失败: ' + err.message,
              type: 'error'
            });
          });
        } else {
          this.$message({
            message: '标签已存在',
            type: 'warning'
          });
        }
        this.newTagInput = '';
        this.newTagInputVisible = false;
      }
    },
    /**
     * 删除标签
     */
    removeTag: function removeTag(tag) {
      var _this32 = this;
      // 调用删除接口
      // 【操作埋点】2026-05-25 pc_shop_edit_1 删除商户标签
      this.$post('agentapi/store/deleteLabel', {
        id: tag.id
      }, {
        operation_option: '删除标签',
        content: "\u6807\u7B7EID\uFF1A".concat(tag.id),
        operation_id: 'pc_shop_edit_1'
      }).then(function (res) {
        // 删除成功后更新本地标签列表
        var index = _this32.currentStoreTags.findIndex(function (t) {
          return t.id === tag.id;
        });
        if (index > -1) {
          _this32.currentStoreTags.splice(index, 1);
        }
        _this32.$message({
          message: '标签删除成功',
          type: 'success'
        });
      }).catch(function (err) {
        _this32.$message({
          message: '标签删除失败: ' + err.message,
          type: 'error'
        });
      });
    },
    /**
     * 保存标签更改（编辑标签）
     */
    saveTags: function saveTags() {
      var _this33 = this;
      // 创建一个Promise数组来处理所有标签的更新
      var updatePromises = [];
      // 遍历所有标签，找出修改过的标签并更新
      this.currentStoreTags.forEach(function (tag) {
        // 如果标签有id且不是临时生成的（即从服务器获取的），说明可能是修改过的
        if (tag.id && !String(tag.id).startsWith('temp_')) {
          // 这里我们假设如果标签名被修改过就需要更新
          // 实际项目中可以通过对比原始数据来判断是否需要更新
          updatePromises.push(
          // 【操作埋点】2026-05-25 pc_shop_edit_1 编辑商户标签
          _this33.$post('agentapi/store/editLabel', {
            label_name: tag.label_name,
            id: tag.id
          }, {
            operation_option: '编辑标签',
            content: "\u6807\u7B7EID\uFF1A".concat(tag.id, "\uFF0C\u6807\u7B7E\u540D\uFF1A").concat(tag.label_name),
            operation_id: 'pc_shop_edit_1'
          }).then(function (res) {
            return res;
          }).catch(function (err) {
            // 捕获单个标签更新失败的情况
            _this33.$message({
              message: "\u6807\u7B7E\"".concat(tag.label_name, "\"\u66F4\u65B0\u5931\u8D25: ").concat(err.message),
              type: 'error'
            });
            return Promise.reject(err);
          }));
        }
      });

      // 执行所有更新操作
      if (updatePromises.length > 0) {
        Promise.all(updatePromises).then(function () {
          // 更新表格中的数据
          _this33.list = _this33.list.map(function (item) {
            if (item.id === _this33.currentStore.id) {
              return _objectSpread(_objectSpread({}, item), {}, {
                label_list: (0, _toConsumableArray2.default)(_this33.currentStoreTags)
              });
            }
            return item;
          });
          _this33.$message({
            message: '标签保存成功',
            type: 'success'
          });
          _this33.tagDialogVisible = false;
        }).catch(function () {
          // 有错误已经在各自的catch中处理了
        });
      } else {
        // 没有需要更新的标签，直接关闭对话框
        this.list = this.list.map(function (item) {
          if (item.id === _this33.currentStore.id) {
            return _objectSpread(_objectSpread({}, item), {}, {
              label_list: (0, _toConsumableArray2.default)(_this33.currentStoreTags)
            });
          }
          return item;
        });
        this.$message({
          message: '标签保存成功',
          type: 'success'
        });
        this.tagDialogVisible = false;
      }
    },
    /**
     * 设备成本价计算
     * @param {Object} row
     */
    breakEvenCalculationFun: function breakEvenCalculationFun(row) {
      this.breakEvenDialog = true;
      this.currentShopInfo = row;
      // 初始化计算器数据
      this.getCalculateTotalCost();
      this.incomeRecords = [];
      // 启动设备成本监听器
      this.watchDeviceCostChanges();
    },
    /**
     * 获取计算设备成本
     */
    getCalculateTotalCost: function getCalculateTotalCost() {
      var _this34 = this;
      // 设置加载状态
      this.calculateCostLoading = true;
      this.$get('agentapi/store/getStoreBreakEvenCost', {
        store_id: this.currentShopInfo.id,
        device_type: this.selectedDeviceType
      }).then(function (res) {
        if (!res) {
          // 无数据即置零
          _this34.costForm.remark = '';
          _this34.costForm.totalCost = 0;
          _this34.costForm.deviceCost = 0;
          _this34.costForm.installationCost = 0;
          _this34.costForm.laborCost = 0;
          _this34.costForm.otherCost = 0;
          // 初始化投资比例数据
          _this34.investmentRatio = {
            manage: '',
            partner: '',
            proxy: '',
            salesperson: '',
            promoter: '',
            merchants: ''
          };
        } else {
          _this34.costForm.remark = res.remark;
          _this34.costForm.deviceCost = res.device_cost;
          _this34.costForm.installationCost = res.install_cost;
          _this34.costForm.laborCost = res.labor_cost;
          _this34.costForm.otherCost = res.other_cost;
          // 总成本 = 设备成本 + 安装费用 + 人工成本 + 其他成本
          var totalCost = parseFloat(res.device_cost || 0) + parseFloat(res.install_cost || 0) + parseFloat(res.labor_cost || 0) + parseFloat(res.other_cost || 0);
          // 更新总成本字段
          _this34.costForm.totalCost = totalCost.toFixed(2);

          // 处理投资比例数据
          if (res.investment_ratio && (0, _typeof2.default)(res.investment_ratio) === 'object') {
            // 如果是对象格式，直接赋值
            _this34.investmentRatio = res.investment_ratio;
          } else if (res.investment_ratio && typeof res.investment_ratio === 'string') {
            // 如果是字符串格式，尝试解析JSON
            try {
              _this34.investmentRatio = JSON.parse(res.investment_ratio);
            } catch (e) {
              console.error('解析投资比例数据失败:', e);
              // 如果解析失败，使用默认空值
              _this34.investmentRatio = {
                manage: '',
                partner: '',
                proxy: '',
                salesperson: '',
                promoter: '',
                merchants: ''
              };
            }
          } else {
            // 如果没有投资比例数据，初始化为空
            _this34.investmentRatio = {
              manage: '',
              partner: '',
              proxy: '',
              salesperson: '',
              promoter: '',
              merchants: ''
            };
          }
        }
      }).catch(function (err) {
        _this34.$message({
          message: '获取设备成本失败: ' + err.msg,
          type: 'error'
        });
      }).finally(function () {
        // 确保无论请求成功还是失败都关闭加载状态
        _this34.calculateCostLoading = false;
        // 获取设备成本周期数据
        _this34.getBreakEvenCycleData();
      });
    },
    /**
     * 计算总成本
     */
    calculateTotalCost: function calculateTotalCost() {
      var deviceCost = parseFloat(this.costForm.deviceCost) || 0;
      var installationCost = parseFloat(this.costForm.installationCost) || 0;
      var laborCost = parseFloat(this.costForm.laborCost) || 0;
      var otherCost = parseFloat(this.costForm.otherCost) || 0;

      // 总成本 = 设备成本 + 安装费用 + 人工成本 + 其他成本
      var totalCost = deviceCost + installationCost + laborCost + otherCost;

      // 更新总成本字段
      this.costForm.totalCost = totalCost.toFixed(2);
    },
    /**
     * 保存计算设备成本
     */
    saveCalculateTotalCost: function saveCalculateTotalCost() {
      var _this35 = this;
      this.$post('agentapi/store/saveStoreBreakEvenCost', {
        store_id: this.currentShopInfo.id,
        device_type: this.selectedDeviceType,
        device_cost: this.costForm.deviceCost,
        install_cost: this.costForm.installationCost,
        labor_cost: this.costForm.laborCost,
        other_cost: this.costForm.otherCost,
        remark: this.costForm.remark,
        investment_ratio: this.investmentRatio
      }).then(function (res) {
        // 计算总成本
        var deviceCost = parseFloat(_this35.costForm.deviceCost) || 0;
        var installationCost = parseFloat(_this35.costForm.installationCost) || 0;
        var laborCost = parseFloat(_this35.costForm.laborCost) || 0;
        var otherCost = parseFloat(_this35.costForm.otherCost) || 0;
        // 总成本 = 设备成本 + 安装费用 + 其他成本
        var totalCost = deviceCost + installationCost + laborCost + otherCost;
        // 更新总成本字段
        _this35.costForm.totalCost = totalCost.toFixed(2);
        // 提示保存成功
        _this35.$message({
          message: '保存成功',
          type: 'success'
        });
        // 获取设备成本周期数据
        _this35.getBreakEvenCycleData();
      }).catch(function (err) {
        _this35.$message({
          message: '保存失败: ' + err.message,
          type: 'error'
        });
      });
    },
    /**
     * 验证数字输入
     */
    validateNumber: function validateNumber(eventOrValue, fieldName) {
      // 确保fieldName存在
      if (!fieldName) {
        return;
      }

      // 处理输入参数，可能是事件对象或直接的值
      var value;
      if (eventOrValue && (0, _typeof2.default)(eventOrValue) === 'object' && eventOrValue.target) {
        // 如果是事件对象
        value = eventOrValue.target.value;
      } else {
        // 如果是直接的值
        value = eventOrValue;
      }

      // 确保value存在且为字符串
      if (value === undefined || value === null) {
        value = '';
      }

      // 只允许数字和小数点，移除非数字字符
      var val = String(value).replace(/[^\d.]/g, '');

      // 防止多个小数点
      var parts = val.split('.');
      if (parts.length > 2) {
        val = parts[0] + '.' + parts.slice(1).join('');
      }

      // 限制小数位数为2位
      if (parts.length === 2 && parts[1].length > 2) {
        val = parts[0] + '.' + parts[1].substring(0, 2);
      }

      // 更新对应的字段值
      if (this.costForm && this.costForm[fieldName] !== undefined) {
        this.costForm[fieldName] = val;
      }

      // this.calculateDeviceTotalCostByType(fieldName)
    },
    /**
     * 验证投资比例输入
     * @param eventOrValue 输入值或事件对象
     * @param fieldName 字段名称
     */
    validateInvestmentRatio: function validateInvestmentRatio(eventOrValue, fieldName) {
      // 确保fieldName存在
      if (!fieldName) {
        return;
      }

      // 处理输入参数，可能是事件对象或直接的值
      var value;
      if (eventOrValue && (0, _typeof2.default)(eventOrValue) === 'object' && eventOrValue.target) {
        // 如果是事件对象
        value = eventOrValue.target.value;
      } else {
        // 如果是直接的值
        value = eventOrValue;
      }

      // 确保value存在且为字符串
      if (value === undefined || value === null) {
        value = '';
      }

      // 只允许数字和小数点，移除非数字字符
      var val = String(value).replace(/[^\d.]/g, '');

      // 防止多个小数点
      var parts = val.split('.');
      if (parts.length > 2) {
        val = parts[0] + '.' + parts.slice(1).join('');
      }

      // 限制小数位数为2位
      if (parts.length === 2 && parts[1].length > 2) {
        val = parts[0] + '.' + parts[1].substring(0, 2);
      }

      // 转换为数字进行范围检查
      var numValue = parseFloat(val);

      // 限制数值范围在0-100之间
      if (!isNaN(numValue)) {
        if (numValue > 100) {
          val = '100';
          this.$message({
            message: '投资比例不能超过100%',
            type: 'warning'
          });
        } else if (numValue < 0) {
          val = '0';
        }
      }

      // 更新对应的字段值
      if (this.investmentRatio && this.investmentRatio[fieldName] !== undefined) {
        this.investmentRatio[fieldName] = val;
      }

      // 验证总和不超过100%
      this.validateInvestmentRatioTotal();
    },
    /**
     * 验证投资比例总和不超过100%
     */
    validateInvestmentRatioTotal: function validateInvestmentRatioTotal() {
      var _this36 = this;
      // 计算所有投资比例的总和
      var ratioFields = ['manage', 'partner', 'proxy', 'salesperson', 'promoter', 'merchants'];
      var total = 0;
      ratioFields.forEach(function (field) {
        var value = parseFloat(_this36.investmentRatio[field]) || 0;
        total += value;
      });

      // 如果总和超过100%，给出警告
      if (total > 100) {
        this.$message({
          message: "\u6295\u8D44\u6BD4\u4F8B\u603B\u548C\u4E0D\u80FD\u8D85\u8FC7100%\uFF0C\u5F53\u524D\u603B\u548C\u4E3A".concat(total.toFixed(2), "%"),
          type: 'warning'
        });
      }
    },
    /**
     * 根据设备类型计算总设备成本费用
     */
    calculateDeviceTotalCostByType: function calculateDeviceTotalCostByType(costField) {
      // 获取对应设备的数量和成本
      var deviceCount = 0;
      var deviceCost = 0;
      switch (costField) {
        case 'cdbCost':
          deviceCount = this.currentShopInfo.cdbcount || 0;
          deviceCost = parseFloat(this.costForm.cdbCost) || 0;
          break;
        case 'cdxCost':
          deviceCount = this.currentShopInfo.cdxcount || 0;
          deviceCost = parseFloat(this.costForm.cdxCost) || 0;
          break;
        case 'cdz10Cost':
          deviceCount = this.currentShopInfo.cdz10count || 0;
          deviceCost = parseFloat(this.costForm.cdz10Cost) || 0;
          break;
        case 'cdz2Cost':
          deviceCount = this.currentShopInfo.cdz2count || 0;
          deviceCost = parseFloat(this.costForm.cdz2Cost) || 0;
          break;
        case 'cdz2lyCost':
          deviceCount = this.currentShopInfo.cdz2lycount || 0;
          deviceCost = parseFloat(this.costForm.cdz2lyCost) || 0;
          break;
        case 'cdz2hpCost':
          deviceCount = this.currentShopInfo.cdz2hpcount || 0;
          deviceCost = parseFloat(this.costForm.cdz2hpCost) || 0;
          break;
        case 'zmcdbCost':
          deviceCount = this.currentShopInfo.zmcdbcount || 0;
          deviceCost = parseFloat(this.costForm.zmcdbCost) || 0;
          break;
        case 'lykgczCost':
          deviceCount = this.currentShopInfo.lykgczcount || 0;
          deviceCost = parseFloat(this.costForm.lykgczCost) || 0;
          break;
        default:
          return;
      }

      // 计算当前设备类型的总成本
      var currentDeviceTotalCost = deviceCount * deviceCost;
      var existingDeviceCost = parseFloat(this.costForm.deviceCost) || 0;

      // 将计算出的成本赋值给总设备成本字段
      this.costForm.deviceCost = (currentDeviceTotalCost + existingDeviceCost).toFixed(2);
      // 重新计算总成本
      this.calculateTotalCost();
      this.$message({
        message: "\u8BBE\u5907\u6210\u672C\u5DF2\u66F4\u65B0\u4E3A: ".concat(currentDeviceTotalCost.toFixed(2), " \u5143"),
        type: 'success'
      });
    },
    /**
     * 根据设备类型计算设备总的安装费用
     * @param costField
     */
    calcDeviceInstallationTotalCostByType: function calcDeviceInstallationTotalCostByType(costField) {
      // 获取对应设备的数量和安装费用
      var deviceCount = 0;
      var deviceInstallCost = 0;
      switch (costField) {
        case 'cdbInstallCost':
          deviceCount = this.currentShopInfo.cdbcount || 0;
          deviceInstallCost = parseFloat(this.costForm.cdbInstallCost) || 0;
          break;
        case 'cdxInstallCost':
          deviceCount = this.currentShopInfo.cdxcount || 0;
          deviceInstallCost = parseFloat(this.costForm.cdxInstallCost) || 0;
          break;
        case 'cdz10InstallCost':
          deviceCount = this.currentShopInfo.cdz10count || 0;
          deviceInstallCost = parseFloat(this.costForm.cdz10InstallCost) || 0;
          break;
        case 'cdz2InstallCost':
          deviceCount = this.currentShopInfo.cdz2count || 0;
          deviceInstallCost = parseFloat(this.costForm.cdz2InstallCost) || 0;
          break;
        case 'cdz2lyInstallCost':
          deviceCount = this.currentShopInfo.cdz2lycount || 0;
          deviceInstallCost = parseFloat(this.costForm.cdz2lyInstallCost) || 0;
          break;
        case 'cdz2hpInstallCost':
          deviceCount = this.currentShopInfo.cdz2hpcount || 0;
          deviceInstallCost = parseFloat(this.costForm.cdz2hpInstallCost) || 0;
          break;
        case 'zmcdbInstallCost':
          deviceCount = this.currentShopInfo.zmcdbcount || 0;
          deviceInstallCost = parseFloat(this.costForm.zmcdbInstallCost) || 0;
          break;
        case 'lykgczInstallCost':
          deviceCount = this.currentShopInfo.lykgczcount || 0;
          deviceInstallCost = parseFloat(this.costForm.lykgczInstallCost) || 0;
          break;
        default:
          return;
      }
      var currentTotal = deviceCount * deviceInstallCost;
      var existing = parseFloat(this.costForm.installationCost) || 0;
      this.costForm.installationCost = (currentTotal + existing).toFixed(2);
      this.calculateTotalCost();
      this.$message({
        message: "\u5B89\u88C5\u8D39\u7528\u5DF2\u66F4\u65B0\u4E3A: ".concat(currentTotal.toFixed(2), " \u5143"),
        type: 'success'
      });
    },
    /**
     * 根据设备类型计算设备总的人工费用
     * @param costField
     */
    calcDeviceLaborTotalCostByType: function calcDeviceLaborTotalCostByType(costField) {
      // 获取对应设备的数量和人工费用
      var deviceCount = 0;
      var deviceLaborCost = 0;
      switch (costField) {
        case 'cdbLaborCost':
          deviceCount = this.currentShopInfo.cdbcount || 0;
          deviceLaborCost = parseFloat(this.costForm.cdbLaborCost) || 0;
          break;
        case 'cdxLaborCost':
          deviceCount = this.currentShopInfo.cdxcount || 0;
          deviceLaborCost = parseFloat(this.costForm.cdxLaborCost) || 0;
          break;
        case 'cdz10LaborCost':
          deviceCount = this.currentShopInfo.cdz10count || 0;
          deviceLaborCost = parseFloat(this.costForm.cdz10LaborCost) || 0;
          break;
        case 'cdz2LaborCost':
          deviceCount = this.currentShopInfo.cdz2count || 0;
          deviceLaborCost = parseFloat(this.costForm.cdz2LaborCost) || 0;
          break;
        case 'cdz2lyLaborCost':
          deviceCount = this.currentShopInfo.cdz2lycount || 0;
          deviceLaborCost = parseFloat(this.costForm.cdz2lyLaborCost) || 0;
          break;
        case 'cdz2hpLaborCost':
          deviceCount = this.currentShopInfo.cdz2hpcount || 0;
          deviceLaborCost = parseFloat(this.costForm.cdz2hpLaborCost) || 0;
          break;
        case 'zmcdbLaborCost':
          deviceCount = this.currentShopInfo.zmcdbcount || 0;
          deviceLaborCost = parseFloat(this.costForm.zmcdbLaborCost) || 0;
          break;
        case 'lykgczLaborCost':
          deviceCount = this.currentShopInfo.lykgczcount || 0;
          deviceLaborCost = parseFloat(this.costForm.lykgczLaborCost) || 0;
          break;
        default:
          return;
      }
      var currentTotal = deviceCount * deviceLaborCost;
      var existing = parseFloat(this.costForm.laborCost) || 0;
      this.costForm.laborCost = (currentTotal + existing).toFixed(2);
      this.calculateTotalCost();
      this.$message({
        message: "\u4EBA\u5DE5\u8D39\u7528\u5DF2\u66F4\u65B0\u4E3A: ".concat(currentTotal.toFixed(2), " \u5143"),
        type: 'success'
      });
    },
    /**
     * 根据设备类型计算设备总的其他费用
     * @param costField
     */
    calcDeviceOtherTotalCostByType: function calcDeviceOtherTotalCostByType(costField) {
      // 获取对应设备的数量和其他费用
      var deviceCount = 0;
      var deviceOtherCost = 0;
      switch (costField) {
        case 'cdbOtherCost':
          deviceCount = this.currentShopInfo.cdbcount || 0;
          deviceOtherCost = parseFloat(this.costForm.cdbOtherCost) || 0;
          break;
        case 'cdxOtherCost':
          deviceCount = this.currentShopInfo.cdxcount || 0;
          deviceOtherCost = parseFloat(this.costForm.cdxOtherCost) || 0;
          break;
        case 'cdz10OtherCost':
          deviceCount = this.currentShopInfo.cdz10count || 0;
          deviceOtherCost = parseFloat(this.costForm.cdz10OtherCost) || 0;
          break;
        case 'cdz2OtherCost':
          deviceCount = this.currentShopInfo.cdz2count || 0;
          deviceOtherCost = parseFloat(this.costForm.cdz2OtherCost) || 0;
          break;
        case 'cdz2lyOtherCost':
          deviceCount = this.currentShopInfo.cdz2lycount || 0;
          deviceOtherCost = parseFloat(this.costForm.cdz2lyOtherCost) || 0;
          break;
        case 'cdz2hpOtherCost':
          deviceCount = this.currentShopInfo.cdz2hpcount || 0;
          deviceOtherCost = parseFloat(this.costForm.cdz2hpOtherCost) || 0;
          break;
        case 'zmcdbOtherCost':
          deviceCount = this.currentShopInfo.zmcdbcount || 0;
          deviceOtherCost = parseFloat(this.costForm.zmcdbOtherCost) || 0;
          break;
        case 'lykgczOtherCost':
          deviceCount = this.currentShopInfo.lykgczcount || 0;
          deviceOtherCost = parseFloat(this.costForm.lykgczOtherCost) || 0;
          break;
        default:
          return;
      }
      var currentTotal = deviceCount * deviceOtherCost;
      var existing = parseFloat(this.costForm.otherCost) || 0;
      this.costForm.otherCost = (currentTotal + existing).toFixed(2);
      this.calculateTotalCost();
      this.$message({
        message: "\u5176\u4ED6\u8D39\u7528\u5DF2\u66F4\u65B0\u4E3A: ".concat(currentTotal.toFixed(2), " \u5143"),
        type: 'success'
      });
    },
    /**
     * 获取回本周期数据集和
     */
    getBreakEvenCycleData: function getBreakEvenCycleData() {
      var _this37 = this;
      // 设置加载状态
      this.calculateCostLoading = true;
      // 初始化
      this.breakEvenDays = 0;
      this.breakEvenPercentage = 0;
      this.averageDailyIncome = 0;
      this.recoveredCost = 0;
      this.remainingCost = 0;
      this.daysSinceOperation = 0;
      this.averageChangeMoneyMonth = 0;
      this.$get('agentapi/store/getStoreBreakEvenCycleData', {
        store_id: this.currentShopInfo.id,
        device_type: this.selectedDeviceType
      }).then(function (res) {
        // 待回本周期（天数）
        _this37.breakEvenDays = res.break_even_cycle;
        // 已回本比例
        _this37.breakEvenPercentage = res.break_even_percentage;
        // 平均日收入
        _this37.averageDailyIncome = res.average_change_money;
        // 已收回成本
        _this37.recoveredCost = res.total_change_money;
        // 剩余待收回成本
        _this37.remainingCost = res.remain_cost;
        // 已运营总天数
        _this37.daysSinceOperation = res.days_since_operation;
        // 平均月收入
        _this37.averageChangeMoneyMonth = res.average_change_money_month;

        // 处理回本占比数据
        if (res.change_money_ratio) {
          try {
            _this37.recoveryRatio = typeof res.change_money_ratio === 'string' ? JSON.parse(res.change_money_ratio) : res.change_money_ratio;
          } catch (e) {
            console.error('解析回本占比数据失败:', e);
            // 如果解析失败，使用默认空值
            _this37.recoveryRatio = {
              manage: '',
              partner: '',
              proxy: '',
              salesperson: '',
              promoter: '',
              merchants: ''
            };
          }
        } else {
          // 如果没有回本占比数据，初始化为空
          _this37.recoveryRatio = {
            manage: '',
            partner: '',
            proxy: '',
            salesperson: '',
            promoter: '',
            merchants: ''
          };
          _this37.$message({
            message: "商户暂无订单数据。",
            type: 'warning'
          });
        }
      }).catch(function (err) {
        _this37.$message({
          message: '获取回本周期数据集和失败: ' + err.msg,
          type: 'warning'
        });
      }).finally(function () {
        // 确保无论请求成功还是失败都关闭加载状态
        _this37.calculateCostLoading = false;
      });
    },
    /**
     * 添加计算设备总数的方法
     * @param shopInfo
     * @returns {number}
     */
    getDeviceCount: function getDeviceCount(shopInfo) {
      var count = 0;
      if (shopInfo.cdbcount > 0) count++;
      if (shopInfo.cdxcount > 0) count++;
      if (shopInfo.cdz10count > 0) count++;
      if (shopInfo.cdz2count > 0) count++;
      if (shopInfo.cdz2lycount > 0) count++;
      if (shopInfo.cdz2hpcount > 0) count++;
      if (shopInfo.zmcdbcount > 0) count++;
      if (shopInfo.lykgczcount > 0) count++;
      return count;
    },
    /**
     * 获取商店盈利基础数据到列表
     */
    getBreakEvenCycleDataToList: function () {
      var _getBreakEvenCycleDataToList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this38 = this;
        var listData, requests;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 为列表中的每一项初始化状态
              listData = this.list.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  break_even_profit: "读取中",
                  total_change_money: "读取中",
                  days_since_operation: "读取中"
                });
              }); // 更新列表以显示加载状态
              this.list = listData;

              // 创建所有API请求的Promise数组
              requests = listData.map(function (item) {
                return _this38.$get('agentapi/store/getStoreBreakEvenCycleData', {
                  store_id: item.id,
                  device_type: 0
                }).then(function (res) {
                  // 成功时更新对应项的数据
                  var index = _this38.list.findIndex(function (i) {
                    return i.id === item.id;
                  });
                  if (index !== -1) {
                    // 处理各方回本占比数据
                    var recoveryData = {
                      manage: '',
                      partner: '',
                      proxy: '',
                      salesperson: '',
                      promoter: '',
                      merchants: ''
                    };

                    // 检查并处理 change_money_ratio 数据
                    if (res.change_money_ratio && (0, _typeof2.default)(res.change_money_ratio) === 'object') {
                      // 如果存在有效的回本占比数据，则转换为百分比显示
                      var totalChangeMoney = parseFloat(res.total_change_money) || 0;
                      if (totalChangeMoney > 0) {
                        recoveryData = {
                          manage: res.change_money_ratio.manage ? (parseFloat(res.change_money_ratio.manage) / totalChangeMoney * 100).toFixed(2) : '0.00',
                          partner: res.change_money_ratio.partner ? (parseFloat(res.change_money_ratio.partner) / totalChangeMoney * 100).toFixed(2) : '0.00',
                          proxy: res.change_money_ratio.proxy ? (parseFloat(res.change_money_ratio.proxy) / totalChangeMoney * 100).toFixed(2) : '0.00',
                          salesperson: res.change_money_ratio.salesperson ? (parseFloat(res.change_money_ratio.salesperson) / totalChangeMoney * 100).toFixed(2) : '0.00',
                          promoter: res.change_money_ratio.promoter ? (parseFloat(res.change_money_ratio.promoter) / totalChangeMoney * 100).toFixed(2) : '0.00',
                          merchants: res.change_money_ratio.merchants ? (parseFloat(res.change_money_ratio.merchants) / totalChangeMoney * 100).toFixed(2) : '0.00'
                        };
                      }
                    }
                    _this38.$set(_this38.list, index, _objectSpread(_objectSpread({}, _this38.list[index]), {}, {
                      break_even_profit: parseFloat((res.total_change_money - res.total_cost).toFixed(2)),
                      total_change_money: res.total_change_money,
                      days_since_operation: res.days_since_operation,
                      recovery_ratio: recoveryData // 存储回本占比数据
                    }));
                  }
                }).catch(function (err) {
                  // 失败时更新对应项的数据
                  var index = _this38.list.findIndex(function (i) {
                    return i.id === item.id;
                  });
                  if (index !== -1) {
                    _this38.$set(_this38.list, index, _objectSpread(_objectSpread({}, _this38.list[index]), {}, {
                      break_even_profit: "数据获取异常",
                      total_change_money: "数据获取异常",
                      days_since_operation: "数据获取异常"
                    }));
                  }
                });
              }); // 等待所有请求完成
              _context2.next = 1;
              return Promise.all(requests);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getBreakEvenCycleDataToList() {
        return _getBreakEvenCycleDataToList.apply(this, arguments);
      }
      return getBreakEvenCycleDataToList;
    }(),
    /**
     * 显示充值金额配置弹窗
     * @param {Object} row 商户数据
     */
    showRechargeConfig: function showRechargeConfig(row) {
      var _this39 = this;
      this.rechargeConfigObj = {
        aid: row.aid,
        is_use_self_banner: 0,
        config_list: [{
          price: 50,
          send: 8
        }, {
          price: 30,
          send: 5
        }, {
          price: 20,
          send: 2
        }, {
          price: 10,
          send: '0.00'
        }, {
          price: 100,
          send: '0.00'
        }, {
          price: 200,
          send: '0.00'
        }]
      };
      this.rechargeConfigDialog = true;
      this.$get('agentapi/banner/getRechargeConfig', {
        aid: row.aid
      }).then(function (res) {
        if (res && res.config_list) {
          res.config_list.forEach(function (item, index) {
            if (_this39.rechargeConfigObj.config_list[index]) {
              _this39.rechargeConfigObj.config_list[index].price = item.price || _this39.rechargeConfigObj.config_list[index].price;
              _this39.rechargeConfigObj.config_list[index].send = item.send || '';
            }
          });
        }
      }).catch(function () {
        console.log('获取充值配置失败，使用默认配置');
      });
      this.$get('agentapi/admin/getAdminOtherSetting', {
        aid: row.aid
      }).then(function (res) {
        if (res) {
          _this39.rechargeConfigObj.is_use_self_banner = res.is_use_self_banner || 0;
        }
      }).catch(function () {
        console.log('获取设置失败，使用默认值');
      });
    },
    /**
     * 保存充值金额配置
     */
    saveRechargeConfig: function saveRechargeConfig() {
      var _this40 = this;
      var list = this.rechargeConfigObj.config_list;
      for (var i = 0; i < list.length; i++) {
        if (!list[i].price || parseFloat(list[i].price) <= 0) {
          this.$message({
            message: "\u7B2C".concat(i + 1, "\u9879\u5145\u503C\u91D1\u989D\u5FC5\u586B\u4E14\u5FC5\u987B\u5927\u4E8E0"),
            type: 'error'
          });
          return;
        }
        if (list[i].send === '' || list[i].send === null) {
          list[i].send = '0.00';
        }
      }
      var load = this.$message({
        duration: 0,
        iconClass: 'el-icon-loading',
        message: '保存中...'
      });
      Promise.all([this.$post('agentapi/banner/saveRechargeConfig', {
        config_list: list,
        aid: this.rechargeConfigObj.aid
      }), this.$post('agentapi/admin/setAdminOtherSetting', {
        is_use_self_banner: this.rechargeConfigObj.is_use_self_banner,
        aid: this.rechargeConfigObj.aid
      })]).then(function () {
        load.close();
        _this40.$message({
          message: '保存成功',
          type: 'success'
        });
        _this40.rechargeConfigDialog = false;
      }).catch(function (err) {
        load.close();
        _this40.$message({
          message: err.msg || '保存失败',
          type: 'error'
        });
      });
    }
  }
};